// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__3SWqZ","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1iFva"};